// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "ai.hacken",
    name: "hAI by Hacken",
    homepage: "https://hacken.ai",
    image_id: "d2ff6baf-5051-4bf2-edec-32450b451000",
    app: {
        browser: "https://hacken.ai",
        ios: "https://apps.apple.com/us/app/hai-by-hacken/id1501384789",
        android: "https://play.google.com/store/apps/details?id=com.hackenai.hackenaiapp&hl=en_US",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "hai://",
        universal: "https://hacken.ai",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map